$(document).ready(function(){

    $('#stoerer_call').on('mouseenter click',function(){
        $('#stoerer_mail').css({'filter':'none'});
        $(this).css({'filter':'invert(100%)'});
        $('.stoerer_address').html('Jetzt anrufen<br><a href="tel:+492349013937">0234 9013937</a><br><a href="tel:+491703085261">0170 3085261</a>');
        $('.stoerer_body').animate({'right':'0'});
    });

    $('#stoerer_mail').on('mouseenter click', function(){
        $('#stoerer_call').css({'filter':'none'});
        $(this).css({'filter':'invert(100%)'});
        $('.stoerer_address').html('<a href="mailto:&#109;&#97;&#108;&#101;&#114;&#98;&#101;&#116;&#114;&#105;&#101;&#98;&#45;&#103;&#101;&#114;&#115;&#116;&#101;&#109;&#101;&#105;&#101;&#114;&#64;&#116;&#45;&#111;&#110;&#108;&#105;&#110;&#101;&#46;&#100;&#101;">Email schreiben</a>');
        $('.stoerer_body').animate({'right':'0'});
    });

    $('.stoerer').on('mouseleave', function(){
        $('.stoerer_icon').css({'filter':'none'});
        $('.stoerer_body').animate({'right':'-15rem'});
    });

    $('.stoerer_close').on('click', function(){
        $('.stoerer_icon').css({'filter':'none'});
        $('.stoerer_body').animate({'right':'-15rem'});
    });

});